// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum DesigoOpticState {
  HasNoDesigoOptic = 0,
  HasUnsizedDesigoOptic = 1,
  HasSizedDesigoOptic = 2,
}
